import React from 'react';

import { usePartnerInfo, useTemplatesInfo } from '../../hooks/index';

const Partner = (props) => {
  const partner = usePartnerInfo(props);
  const { name, id } = partner;

  const templates = useTemplatesInfo(id);

  console.log('partner ::::::', partner, templates);
  return (
    <div>
      <div>Partner::: { name } { id }</div>
      <ul>
        { Object.keys(templates || {}).map(key => <li key={key}>{templates[key].name}</li>) }
      </ul>
    </div>
    

  );
};

export {
  Partner as Component,
};



// WEBPACK FOOTER //
// ./src/components/partner/index.js